import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { deletePreparation } from '../../services/PreparationService';

const DeleteConfirmModal = ({ open, onClose, onDelete, preparation }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDeletePreparation = async () => {
    setLoading(true);
    try {
      await deletePreparation(preparation.id);
      onDelete();
    } catch (error) {
      console.error('Error deleting preparation:', error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  if (!preparation) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
        <Typography>{t('delete_preparation_confirmation', { name: preparation.name })}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <LoadingButton
          loading={loading}
          onClick={handleDeletePreparation}
          variant="contained"
          color='error'
        >
          {t('delete')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;
